<template>
  <a-modal v-model:open="showDia" title="设置自定义列" width="870px">
    <div>
      <div class="listDiv content" style="width:600px">
        <div class="header">可添加列</div>
        <div class="listDivRightList">
          <div class="checkboxDiv">
            <div class="listDivRight">
              <p class="labelTitle">配置列</p>
              <a-checkbox v-model:checked="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange">全选</a-checkbox>
              <a-checkbox-group v-model:value="checkedValue">
                <a-checkbox v-for="(columnItem,index) in leftColumnData" @change="handleCheckedChange($event, columnItem)" :key="index" :value="columnItem.key" :disabled="columnItem.isFixed" style="width:32%">{{ columnItem.title }}</a-checkbox>
              </a-checkbox-group>
            </div>
          </div>
        </div>
      </div>
      <div class="addDiv content">
        <div class="header"> 已选 {{ checkedValue.length }} / {{leftColumnData.length}} 项
          <span class="clear" @click="resetConfig">重置</span>
        </div>
        <div class="color-list">
          <div v-for="(item,index) in fixedList" :key="index">
            <div class="color-item" style="cursor: default;">
              {{item.title}}
            </div>
          </div>
          <div class="divider"><span>以上是固定项</span></div>
          <div>
            <draggable :list="draggableList" item-key="prop" tag="ul" handle=".drag" append-to-body >
                <template #item="{ element, index }">
                    <div>
                    <div class="color-item2 color-itemList drag">
                        <DragOutlined style="color:#333" />
                        <p class="nameInfo">  {{element.title}}  </p>
                        <CloseOutlined style="color: rgb(51, 51, 51);" @click="deleteSingleColumn(element, index)" />
                    </div>
                    </div>
                </template>
            </draggable>
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <a-button @click="showDia = false">取 消</a-button>
        <a-button type="primary" @click="onSubmit">应 用</a-button>
      </div>
    </template>
  </a-modal>
 
</template>

<script setup lang="ts">
import _ from 'lodash'
import { DragOutlined, CloseOutlined } from '@ant-design/icons-vue';
import draggable from "vuedraggable";
import { ref, getCurrentInstance, defineEmits, defineExpose, defineProps} from 'vue';
import { message } from 'ant-design-vue';

const { proxy } = getCurrentInstance();
const emits = defineEmits(['cancel', 'ok'])

const showDia = ref(false)

// 左侧展示的全部列
const leftColumnData = ref([])
// 右侧上方固定列
const fixedList = ref([])
// 右侧下方已经选择的列
const draggableList = ref([])

const props = defineProps({
  resetColumn: {
    type: Array
  },
  storageName: {
    type: String,
    required: true,
  }
});

const checkAll = ref(false);
const isIndeterminate = ref(false);
const checkedValue = ref([]);
const hasAction = ref(false)
const actionObj = ref(null)

function show() {
  showDia.value = true
  initColumns()
}

function initColumns() {

  let origin = _.cloneDeep(props.resetColumn)

  hasAction.value = origin.findIndex(v=>v.key=='action') > -1
  console.log('hasAction.value', hasAction.value)
  origin = origin.filter(v=>v.key!='action')
    
  console.log('origin', origin)
  let selected = []

  let savedColumns = localStorage.getItem(props.storageName) || null

  console.log('savedColumns', savedColumns)
  if (savedColumns) {
    // 有保存的column
    savedColumns = JSON.parse(savedColumns)
    leftColumnData.value = origin.map(val=>{
      val['isChoosed'] = savedColumns.includes(val.key)
      return val
    })
    savedColumns.forEach(val=>{
      let obj = leftColumnData.value.find(v=>v.key==val)
      if (obj) selected.push(obj)
    })
    // selected = leftColumnData.value.filter(v=>v.isChoosed)
  } else {
    leftColumnData.value = origin.map(v=>({...v,isChoosed: true,}))
    selected = leftColumnData.value
  }

  draggableList.value =  selected.filter(v=>!v.isFixed).filter(Boolean)

  fixedList.value = leftColumnData.value.filter(v=>v.isFixed)

  checkedValue.value = leftColumnData.value.filter(v=>v.isChoosed).map(v=>v.key)

  checkAll.value = checkedValue.value.length == leftColumnData.value.length
  
  isIndeterminate.value = !checkAll.value

}

const handleCheckAllChange = (val) => {
  isIndeterminate.value = !checkAll.value
  if (checkAll.value) { // 全选
    leftColumnData.value = leftColumnData.value.map(v=>({...v,isChoosed: true,}))
    checkedValue.value = leftColumnData.value.map(v=>v.key)


    draggableList.value = leftColumnData.value.filter(v=>!v.isFixed)
    
  } else { // 全不选
    leftColumnData.value = leftColumnData.value.map(v=>({...v,isChoosed: v.isFixed}))
    checkedValue.value = leftColumnData.value.filter(v=>v.isFixed).map(v=>v.key)
    
    
    draggableList.value = []
  }
}

function handleCheckedChange(el, item) {
  if (el.target.checked) {
    draggableList.value.push(item)
  } else {
    let index = draggableList.value.findIndex(v=>v.key==item.key)
    draggableList.value.splice(index, 1)
  }
}
async function onSubmit() {
  let saved = draggableList.value.map(v=>v.key)
  let fixed = fixedList.value.map(v=>v.key)
  let fields = fixed.concat(saved)
  console.log('保存', fields)
  if (hasAction.value) {
    fields.push('action')
    console.log('保存1', fields)
  }
  localStorage.setItem(props.storageName, JSON.stringify(fields))
  message.success('设置成功！')
  onCancle()
}

function resetConfig() {
  localStorage.setItem(props.storageName, '')
  initColumns()
}

const onCancle = () => {
  showDia.value = false
  emits("ok")
}

defineExpose({
  show,
});
</script>
<style lang="scss">

.content {
  display: inline-block;
  margin-top: 5px;
  height: 490px;
  border: 1px solid #ebedf0;
  background: #ffffff;
  vertical-align: top;
  font-size: 12px;
  overflow: hidden;
}
.listDivRight {
  display: inline-block;
  overflow: auto;
  .checkboxDiv {
    padding: 0 15px 15px 15px;
    border-bottom: 1px solid #ebedf0;
    &:last-child {
      border-bottom: none;
    }
  }
  .ant-checkbox-wrapper {
    margin-bottom: 6px;
    font-size: 13px;
  }
  .labelTitle {
    padding-top: 15px;
    color: #333333;
    font-weight: 600;
    font-size: 14px;
  }
  .allCheck {
    margin-top: 0 !important;
    font-size: 14px;
    color: #333333;
  }
  .checkbox {
    margin-top: 15px;
    width: 100%;
    font-size: 12px;
  }
}

.content .color-list {
  overflow: auto;
  height: 450px;
}
.content .header {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  padding: 10px 16px;
  width: 100%;
  height: 40px;
  border-bottom: 1px solid #ebedf0;
  background: #f7f8fa;
  color: #646566;
  font-size: 14px;
}
.content .header .clear {
  float: right;
  color: #0650d0;
  cursor: Pointer;
}
.content i {
  color: #c8c9cc;
  font-size: 12px;
}
.content .delIcon {
  float: right;
  margin-top: 3px;
  color: #c8c9cc;
  font-size: 8px;
  cursor: Pointer;
  transform: scale(0.7);
  -webkit-transform: scale(0.7);
}
.listDiv {
  width: 750px;
}
.listDiv .listDivLeft {
  display: inline-block;
  overflow: auto;
  width: 160px;
  height: 450px;
  border-right: 1px solid #ebedf0;
  vertical-align: top;
}
.listDiv .listDivLeft div {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  margin: 12px 16px;
  color: #333333;
  font-size: 14px;
}
.listDiv .listDivLeft .current {
  color: #0650d0;
  font-weight: 600;
}
.listDiv .listDivLeft div:hover {
  color: #0650d0;
  font-weight: 600;
}
.listDiv .listDivRightList {
  display: inline-block;
  overflow: auto;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  width: 100%;
  height: 450px;
}
.listDiv .listDivRightList .checkboxDiv {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  padding: 0 15px 15px 15px;
  border-bottom: 1px solid #ebedf0;
}
.listDiv .listDivRightList .checkboxDiv:last-child {
  border-bottom: none;
}
.listDiv .listDivRightList .labelTitle {
  padding-top: 15px;
  color: #333333;
  font-weight: 600;
  font-size: 14px;
}
.listDiv .listDivRightList .checkbox {
  margin-top: 15px;
  width: 40%;
  font-size: 12px;
}
.addDiv {
  margin-left: 16px;
  width: 203px;
}
.marBom18 {
  margin-bottom: 18px;
}
.pl {
  padding-left: 110px;
}
.header-main-title {
  font-size: 16px;
  color: #333333;
  margin-right: 50px;
}
.header_title {
  color: #4f4e4e;
  font-size: 13px;
}

.cont {
  border-top: 1px solid #ddd;
  padding: 20px;
}
.cont .cont_title {
  font-size: 14px;
  color: #333333;
  margin-bottom: 30px;
}
.cont .cont_flex {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}
.cont .cont_flex ul {
  width: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -ms-flex-pack: distribute;
      justify-content: space-around;
  border-right: 1px solid #ddd;
}
.cont .cont_flex ul li {
  text-align: center;
  font-size: 14px;
}
.cont .cont_flex ul li span {
  color: #afabab;
}
.cont .cont_flex ul li div {
  color: #504d4d;
  margin-top: 12px;
  min-height: 23px;
  font-size: 13px;
}
.cont .cont_flex ul:last-of-type {
  border-right: none;
}
.cont .dange {
  margin-top: 20px;
}
.cont .dange .cordDiv {
  font-size: 14px;
  margin: 0px 20px 0 20px;
}
.cont .dange .cordDiv span {
  color: #afabab;
}
.cont .dange .cordDiv div {
  color: #504d4d;
  margin-top: 12px;
  min-height: 23px;
  font-size: 13px;
}
.mar20 {
  margin: 20px 0;
}
.demo-input-suffix {
  margin-top: 20px;
}

.color-item {
  overflow: hidden;
  margin: 5px auto;
  padding: 6px 7px;
  width: 88%;
  border-radius: 4px;
  background-color: #f7f8fa;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: move;
}
.color-item2 {
  display: flex;
  align-items: center;
  overflow: hidden;
  margin: 5px auto;
  padding: 0px 7px;
  width: 88%;
  border-radius: 4px;
  background-color: #f7f8fa;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.nameInfo {
  display: inline-block;
  overflow: hidden;
  margin-left: 8px;
  margin-bottom: 0;
  height: 30px;
  line-height: 30px;
  width: 138px;
  vertical-align: text-bottom;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.color-itemList:hover {
  background-color: #ebedf0;
}
.divider {
  height: 1px;
  width: 100%;
  background-color: #dcdfe6;
  position: relative;
  margin: 18px 0;
  &>span {
    background-color: #fff;
    padding: 2px 5px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>